import * as React from 'react';
import Container from '@mui/material/Container';

export default function MarloweVideo() {
  return (
    <Container sx={{
      height: "auto",
      aspectRatio: "16 / 9",
      maxHeight: "450px",
    }}>
      <iframe src="https://player.vimeo.com/video/478657027?background=1&amp;autoplay=1&amp;loop=1&amp;muted=1&amp;title=0&amp;byline=0&amp;portrait=0"
        width="100%" 
        height="100%"
        allowfullscreen="" 
        frameborder="0" 
        mozallowfullscreen=""
        title="Kimpton Marlowe Hotel" 
        webkitallowfullscreen="" 
        data-ready="true" />
    </Container>
  );
}
